// prettier-ignore

export const translationRO = {
  'acronym': 'JAS',
  'magazine_title': 'Jurnalul Artelor Spectacolului',
  'department_name': 'Departamentul de Artă Teatrală',
  'cavas_research_center': 'Centrul de Cercetări Avansate în Domeniul Artelor Spectacolului',
  'classification-1': 'Publicație clasificată de către CNCS în categoria „C”, domeniul Teatru și Artele spectacolului.',
  'indexed-by': 'Publicație indexată în:',
  'copyright': 'Toate drepturile rezervate',
  affiliation: {
    'lucian_blaga_university_of_sibiu': 'Universitea „Lucian Blaga” din Sibiu',
    'new_sorbonne_university_paris_3': 'Universitea Sorbonne Nouvelle - Paris III',
    'leeds_beckett_university': 'Universitatea Leeds Beckett',
    'hong_kong_metropolitan_university': 'Hong Kong Metropolitan University'
  },
  title: {
    'president': 'PREȘEDINTE',
    'editor_in_chief': 'REDACTOR-ȘEF',
    'associate_editor': 'EDITOR ASOCIAT',
    'managing_editor': 'EDITOR-ȘEF',
    'secretary': 'SECRETAR DE REDACȚIE',
    'web_and_print': 'WEB & PRINT',
  },
  position: {
    'univ_professor': 'Prof. Univ. Dr.',
    'assoc_professor': 'Lector Dr.',
    'phd_assoc_professor': 'Conf. Univ. Dr.',
    'principal_lecturer': 'Prof. Univ. Dr.',
    'phd_student': 'Doctorand'
  },
  menu: {
    'about': 'Despre',
    'boards': 'Comitete',
    'instructions': 'Instrucțiuni',
    'review': 'Analiză',
    'call_for_papers': 'Call For Papers',
    'archive': 'Arhivă',
    'contact': 'Contact',
  },
  publicationList: {
    title: 'Titlu',
    year: 'Anul publicației',
    download: 'Descarcă',
  },
  pages: {
    index: {
      description: 'Jurnalul Artelor Spectacolului (JAS) e o revistă academică interdisciplinară și interculturală editată de Universitatea „Lucian Blaga” din Sibiu, prin Centrul de Cercetări Avansate în Domeniul Artelor Spectacolului. Revista cuprinde aspecte din aria de studiu a artelor spectacolului, axându-se, în special, pe teatru, operă, dans, muzică, arte vizuale, actorie, film și management cultural. JAS publică articole scrise de artiști și teoreticieni renumiți și încurajează doctoranzii implicați în cercetare prin publicarea articolelor lor. Scopul principal al JAS vizează încurajarea diseminării teoretice a muncii practice realizate de specialiști ai domeniului artelor performative.',
      latest_release_authors: 'În acest număr semnează:',
      partnership: {
        'part1': 'Publicaţie editată de',
        'part2': 'CENTRUL DE CERCETĂRI AVANSATE ÎN DOMENIUL ARTELOR SPECTACOLULUI',
        'part3': 'în colaborare cu',
        'part4': 'TEATRUL NAŢIONAL „RADU STANCA” SIBIU',
        'part5': 'FESTIVALUL INTERNAȚIONAL DE TEATRU DE LA SIBIU',
        'part6': 'DEPARTAMENTUL DE ARTĂ TEATRALĂ din FACULTATEA DE LITERE ŞI ARTE',
        'part7': 'UNIVERSITATEA „LUCIAN BLAGA” DIN SIBIU',
        'part8': 'și',
        'part9': 'EDITURA UNIVERSITĂŢII „LUCIAN BLAGA” DIN SIBIU'
      }
    },
    boards: {
      'sicentific_board': 'Comitet Ştiinţific',
      'walk_of_fame': 'Aleea Celebrităților',
      'editorial_board': 'Comitet Editorial'
    },
    instructions: {
      'part1': 'În vederea asigurării unei structuri unitare, dar și a unei calități formale și de conținut pe care revistele noastre le cer, vă rugăm să luați la cunoștință următoarele aspecte privitoare la exigențele de redactare.',
      'part2': 'Articolele vor fi salvate în formatul .doc sau .docx.',
      'part3': 'Studii / articole cu caracter științific din zona artelor spectacolului a artelor vizuale sau a managementului cultural (între 5 și 15 pagini);',
      'part4': 'Analiză / cronică de spectacol sau de film (între 5 și 15 pagini).',
      'part5': 'Textele vor fi redactate în română, engleză sau franceză și vor fi însoțite de un rezumat (de 90-100 de cuvinte) și de 5 cuvinte-cheie, ambele în limba engleză.',
      'part6': 'Numele autorului, precum și gradul și afilierea sa, va fi scris pe prima pagină, pe primul rând. De asemenea, articolul trimis trebuie să fie însoțit de un short bio narativ al autorului, în limba engleză.',
      'part7': 'Sub titlul textului scris cu Bold, care va fi fixat central pe prima pagină, va fi așezat rezumatul, apoi cuvintele cheie.',
      'part8': 'Textele vor fi redactate pe pagină A4, în Times New Roman, mărimea corpului de literă fiind de 12, la 1,5 rânduri, Justify. Toate marginile paginii trebuie să fie de 2,5cm. ',
      'part9': 'Citatele vor fi introduse între ghilimele și se va indica sursa în note de subsol (footnotes), după următoarea formulă: Numele complet al autorului, Titlul cărții (în italic), Traducătorul (dacă este cazul), Editura, Locul publicării, Anul publicării, Pagina. De exemplu: Eugenio Barba, <i>Teatru: singurătate, meșteșug, revoltă</i>. Traducere de Doina Condrea Derer, Editura Nemira, București, 2013, p. 136.',
      'part10': 'În cazul unor citări preluate din surse web, în nota se subsol se va specifica autorul și titlul articolului și se va atașa link-ul care trimite la informația respectivă, precum și data accesării site-ului.',
      'part11': 'Textele trebuie să prezinte, la sfârșit, o bibliografie în ordine alfabetică, redactată după cum urmează:',
      'part12': 'În cazul cărților: Numele autorului, Prenumele autorului, Titlul cărții, Editura, Locul publicării, Anul publicării.',
      'part13': 'În cazul articolelor din ziare sau reviste: Numele autorului, Prenumele autorului, Titlul articolului, Titlul revistei / ziarului, Numărul, Luna apariției, Locul apariției, Anul de apariție.',
      'part14': 'În cazul articolelor WEB vor fi precizate: Numele autorului, Titlul articolului, Anul publicării, Link către articol, data accesării site-ului.',
      'part15': 'Textele vor fi trimise pe revista.jas@ulbsibiu.ro sau andrei.serban@ulbsibiu.ro.'
    },
    review: {
      'part1': 'Jurnalul Artelor Spectacolului este o publicație academică ce utilizează principiul review-ului arbitrar.',
      'part2': 'Toate lucrările luate în considerare pentru a face obiectul acestei reviste sunt recenzate în mod anonim de cel puțin doi revieweri externi. Reviewerii sunt afiliați unei instituții diferite de cea a autorului.',
      'part3': 'Procesul de recenzare durează între 4 și 6 săptămâni.',
    },
    call_for_papers: {
      'part1': 'Dragi colegi și colaboratori,',
      'part2': 'În vederea publicării revistei Jurnalul Artelor Spectacolului (anul {{year}}, nr. {{issueNumber}}), vă invităm să vă trimiteți articolele, studiile și cronicile până la data de {{date}}.',
      'part3': 'Pentru mai multe detalii privitoare la conținutul și forma materialelor trimise, consultați secțiunea Instrucțiuni pentru Autori.',
    },
    archive: {
      'publishing': 'în curs de publicare',
    },
    contact: {
      'part1': 'Universitatea „Lucian Blaga” din Sibiu',
      'part2': 'Facultatea de Litere şi Arte',
      'part3': 'B-dul Victoriei, nr. 5-7, 550024, Sibiu, România',
      'part4': 'revista.jas@ulbsibiu.ro',
      'part5': 'http://reviste.ulbsibiu.ro/jas',
      'part6': 'ion.tomus@ulbsibiu.ro',
      'part7': 'andrei.serban@ulbsibiu.ro'
    }
  },
  articles: {
    '2023/2-1': 'ION „JIMMY” BESOIU (1931-2017) - ANII UITAȚI DIN SIBIU',
    '2023/2-2': 'TEHNOLOGIE, TEATRU, SOCIETATE. CONSTRUCTIVISM SAU DETERMINISM?',
    '2023/2-3': 'VR THEATRE: THE PARADOX OF REALITY',
    '2023/2-4': 'MASCA DE CARACTER ÎN PEDAGOGIA TEATRALĂ (I)',
    '2023/2-5': 'JOC ȘI JOACĂ. ATELIERUL DE TEATRU ȘI ELEMENTUL LUDIC AL GENERAȚIEI Z',

    '2023/1-1': 'PRIMELE EDIȚII ALE FESTIVALULUI INTERNAȚIONAL DE TEATRU DE LA SIBIU ÎN PAGINILE ZIARULUI TRIBUNA (1993-1998)',
    '2023/1-2': 'PUNEREA ÎN VALOARE A PATRIMONIUL ANTIC: ÎNTRE POTENȚIALUL CULTURAL ȘI OBLIGAȚIA PROTEJĂRII ACESTUIA',
    '2023/1-3': 'ARTELE SPECTACOLULUI ÎN ANII DE ÎNCEPUT AI PRIMULUI FESTIVAL DEDICAT LUI LUCIAN BLAGA (SEBEȘ, 1981-1989)',
    '2023/1-4': 'SEMIOTICA ȘI FIZICA GAGULUI',
    '2023/1-5': 'DE LA CONȘTIINȚĂ LA SPECTACOL TEATRAL. SCURTĂ INCURSIUNE ÎN TEORIILE PSIHOLOGIEI CONTEMPORANE',
    '2023/1-6': 'MODALITĂȚI DE COMUNICARE A MESAJULUI ARTISTIC ÎN MUZICĂ ȘI ARTELE SPECTACOLULUI',
    '2023/1-7': 'ARTA CINETICĂ ÎN SECOLUL XX. CONSIDERAȚII GENERALE',

    '2022/2-1': "FABRICA DE CULTURĂ. INTEGRAREA TEHNICII ÎN SPAȚIUL DE JOC",
    '2022/2-2': "TEATRUL „SATIRICUS”: DRAMATURGIA CONTEMPORAN CA FORM DE REZISTEN ÎN REPUBLICA MOLDOVA",
    '2022/2-3': "EUROPEAN BORDERS, MULTICULTURAL LIMINAL SPACES, AND ARTISTIC RESISTANCE. HOW SIBIU INTERNATIONAL THEATRE FESTIVAL EXEMPLIFIES A EUROPEAN HETEROTOPIC WORKSITE FOR DEMOCRACY",
    '2022/2-4': "FESTIVALUL: ORIGINI ȘI SEMNIFICAȚII. MANIFESTĂRI CIVICE CU CARACTER COMUNITAR DIN SIBIUL SECOLULUI AL XVI-LEA",
    '2022/2-5': "MÂNA, INSTRUMENT ARTISTIC",
    '2022/2-6': "POVESTEA PRINESEI DEOCHEATE. O CLTORIE TEATRAL ÎNTRE EUROPA ȘI JAPONIA",
    '2022/2-7': "MARTOR OCULAR. TEATRUL ÎNTRE TRIREA SCENIC A PREZENTULUI ȘI AMINTIRE",

    '2022/1-1': "IMPORTANŢA IMAGINAŢIEI ÎN CREAŢIA ACTORICEASCĂ",
    '2022/1-2': "PERSONAJUL NEGATIV, ETOSUL ȘI DISCURSUL. STATUTUL ȘI FUNCȚIILE TICĂLOSULUI",
    '2022/1-3': "RELAȚIA ACTOR – SPECTATOR. PUBLIC - PUBLICURI",
    '2022/1-4': "HYBRID TENDENCIES IN THE THEATRICAL PUBLIC SPHERE: A MULTIMODAL ANALYSIS OF 'THE FORREST OF THE HANGED'",
    '2022/1-5': "SUNETUL ÎN TEATRU",
    '2022/1-6': "CORPORALITATE ȘI GESTUALITATE: CONCEPTE ȘI IDEI ÎN METODOLOGIILE DE PREDARE A REGIZORILOR ȘI ACTORILOR RUȘI",
    '2022/1-7': "MENTAL TOUGHNESS FOR ATHLETES OF THE VOICE",

    '2021/2-1': "SEMNIFICAȚII ALE REPREZENTĂRILOR SCENICE: MEPHISTO, ÎN 'FAUST' ȘI 'VISUL UNEI NOPȚI DE VARĂ', ÎN REGIA LUI SILVIU PUCĂRETE",
    '2021/2-2': "PREZENTĂRILE DE MODĂ, UN CAZ ATIPIC DE TEATRALITATE?",
    '2021/2-3': "CINEMAUL LUI LARS VON TRIER. UN ESEU DESPRE ORBIRE",
    '2021/2-4': "REGIA TEATRULUI MUZICAL: MULTICULTURALISM, PLASTICITATE, ORIENT „SPRE” OCCIDENT",
    '2021/2-5': "ARMONIE ŞI MUZICALITATE ÎN POEZIA LUI MIHAI EMINESCU",
    '2021/2-6': "TAP DANCE ÎNTRE FILOSOFIE, FUZIUNE CULTURALĂ ȘI COMUNICARE NONVERBALĂ",
    '2021/2-7': "TEATRALITATEA CONTEMPORANĂ – UN DIALOG AL PREZENŢELOR ŞI PROVOCĂRILOR",

    '2021/1-1': "Editorial: TEATRUL ERA O ARTĂ. ACUM ESTE DOAR O PROFESIE",
    '2021/1-2': "SPECTACOLUL CONSTRÂNGERII",
    '2021/1-3': "„LA HANUL LUI GHIȚĂ”: ASPECTE ALE UNUI CONCEPT ARTISTIC SINERGIC, ÎNTRE CULTURA TRADIȚIONALĂ ȘI ARTELE SPECTACOLULUI",
    '2021/1-4': "TEHNOLOGIE. TEATRU. IMAGINAȚIE",
    '2021/1-5': "FIGHTING FEMININITY: RADICAL FEMINISM AND WOMAN-HATRED IN ANDREA LONG CHU'S 'FEMALES' AND VALERIE SOLANAS' 'UP YOUR ASS'",
    '2021/1-6': "LURKING SHADOWS: MENTAL, EMOTIONAL AND PHYSICAL VIOLENCE IN CARYL CHURCHILL'S 'FAR AWAY",
    '2021/1-7': "THE ACTOR'S WORLD OF SILENCE: STRUCTURAL SIGNIFICATIONS AND ARTISTIC IMPACT OF SILENCE IN THEATRE",
    '2021/1-8': "INSTITUTUL CULTURAL ROMÂN. RELANSARE INTERNAȚIONALĂ RELEVANTĂ",
    '2021/1-9': "TEATRUL DE STRADĂ ȘI PUBLICUL SĂU",
    '2021/1-10': "MANAGEMENTUL PRODUCȚIEI TEHNICE ÎN ARTELE SPECTACOLULUI",
    '2021/1-11': "VALOAREA CULTURII ȘI EVALUAREA IMPACTULUI SOCIAL AL ORGANIZAȚIILOR CULTURALE",

    '2020/2-1': "Isabelle Huppert și Cristian Mungiu",
    '2020/2-2': "Octavian Saiu în dialog cu Radu Jude și Alexandru Dabija",
    '2020/2-3': "Irina Margareta Nistor în dialog cu Maia Morgenstern",
    '2020/2-4': "Stabat Mater Furiosa. Despre muzicalitatea și necesitatea cuvântului care denunță",
    '2020/2-5': "De la arta activă și teatrul comunitar la dezvoltarea teatrului social și observațional ca metodă de predare",
    '2020/2-6': "Monștri și foarfece. Edward Mâini-de- foarfecă de Tim Burton – scurtă analiză",
    '2020/2-7': "Eros și biografie în sonetele shakespeariene",
    '2020/2-8': "Arta vocală, pedagogia și trăirile exprimate",

    '2020/1-1': "Teatrul și spiritul timpului – Societate, artă și politică",
    '2020/1-2': "Teatrul și spiritul timpului – Teatrul și orașul",
    '2020/1-3': "Teatrul și frontierele. Exilul oamenilor de teatru",
    '2020/1-4': "George Banu în dialog cu Wajdi Mouawad",
    '2020/1-5': "George Banu în dialog cu Michèle Noiret",
    '2020/1-6': "Forme ale activității psihice a actorului",
    '2020/1-7': "Ab Initio. Turneele trupelor lui Mihail Pascaly și Matei Millo, primele spectacole de teatru românesc la Sibiu",

    '2019/2-1': "Editorial",
    '2019/2-2': "Regii shakespearieni și cărțile lui Kiefer",
    '2019/2-3': "George Banu, Pippo Delbono",
    '2019/2-4': "George Banu, Emmanuel Demarcy-Mota",
    '2019/2-5': "Jean Michel Ribes, Matei Vișniec",
    '2019/2-6': "Le théâtre absurde au Japon. En attendant Godot au Japon",
    '2019/2-7': "Horia Petra-Petrescu și Revista Teatrală (1913-1914)",
    '2019/2-8': "Spiritul ludic și actorul",
    '2019/2-9': "Raporturi stabile sau agresive între regie și stilul muzical",
    '2019/2-10': "Preambul la analiza limbajului filmic în opera lui Silviu Purcărete",

    '2019/1-1': "George Banu, Ioan Aurel Pop",
    '2019/1-2': "Stan Lai, Octavian Saiu",
    '2019/1-3': "George Banu, Eugenio Barba și Nicola Savarese",
    '2019/1-4': "Conceptul de teatralitate. O receptare critică",
    '2019/1-5': "General Considerations on the Sequel in Contemporary Culture and Performing Arts",
    '2019/1-6': "Gânduri pentru un posibil viitor actor",
    '2019/1-7': "Constelațiile interioare: către o formalizare analitică a artei actorului",
    '2019/1-8': "Ritual și corporalitate în teatrul lui Koffi Kwahulé, Bintou",
    '2019/1-9': "Mit și logos în opera lui Vasile Voiculescu",
    '2019/1-10': "Misterul unui spectacol de mister",
    '2019/1-11': "Realitate și realism în teatru și artele spectacolului",

    '2015/2-1': "Actor de teatru - actor de film: Alegere imposibilă",
    '2015/2-2': "TEATRUL ȘI POLITICA CULTURALĂ ÎN EUROPA ACTUALĂ",
    '2015/2-3': "TEZAURELE CULTURII ȘI REGÂNDIREA LOR ASTĂZI",
    '2015/2-4': "DANSUL CHINEZ PE SCENA LUMII",
    '2015/2-5': "NOAPTEA BUFONILOR",
    '2015/2-6': "O EVIDENŢĂ ACUTĂ",
    '2015/2-7': "Între regie și narațiune: PORTRETIZAREA PERSONAJULUI DRAMATIC ÎN ARTA DIDASCALICĂ LA LUIGI PIRANDELLO",
    '2015/2-8': "Pianista sau omul-obiect. HANEKE ȘI JELINEK: ÎNTRE IMAGINE ȘI TEXT",

    '2015/1-1': "Teatrul înseamnă să te întâlnești",
    '2015/1-2': "Paradise Lost. In Africa and in Europe, with Brett Bailey, the Mesmerizer, in Charge",
    '2015/1-3': "METANIE ȚIE, PĂRINTE!",
    '2015/1-4': "CENSURA TRANSCENDENTALĂ ȘI SENSUL TRAGISMULUI BLAGIAN",
    '2015/1-5': "TEATRUL LUI CARMELO BENE. TEXT SCENIC ȘI ABORDĂRI MUZICALE",
    '2015/1-6': "SPAȚIUL TEATRAL: REPERAJ TEORETIC ȘI ANALIZA TERMINOLOGICĂ",
    '2015/1-7': "INTERSECȚII CU TEATRUL ÎN FILMUL EXPERIMENTAL EUROPEAN",
    '2015/1-8': "WORK METHODS IN MODERN ACTING AND NON-FORMAL EDUCATION THEMES. COMEDY AGAINST VIOLENCE. SPIEGEL PROJECT",

    '2014/2-1': "Umanizare și povești prin teatru",
    '2014/2-2': "Ce înseamnă contemporaneitatea în teatru?",
    '2014/2-3': "The Theatre of Sarah Kane. An Accursed Classic",
    '2014/2-4': "Unpacking Identity: Travelling Cases as Theatrical Props",
    '2014/2-5': "Le monologue dans le théâtre de Bernard-Marie Koltès",
    '2014/2-6': "'Cities on stage', dialog intercultural prin proiecte teatrale",
    '2014/2-7': "Arta activă. o ipoteză",
    '2014/2-8': "Le motif de la déroute dans La Hache de Larry Tremblay",
    '2014/2-9': "Ocolind dogmele: Lars von Trier. Dancer in the Dark",
    '2014/2-10': "Exilul sau izgonirea duhului sfânt",

    '2014/1-1': "Despre aplauze și sensul lor",
    '2014/1-2': "O regie pe care de dispariție: experiența înțelegerii textelor clasice",
    '2014/1-3': "Mozart Steps: despre inteligența pașilor",
    '2014/1-4': "Noi nu suntem în dialog, noi suntem un dialog. Dialog cu George Banu",
    '2014/1-5': "Arta și tehnica one-man show-ului: Domnule și frate Eminescule",
    '2014/1-6': "Reforme teatrale în opera contemporană. Olivier Messiaen. Saint François d'Assise",
    '2014/1-7': "Crimă și destin în tragedia antică",
    '2014/1-8': "Metoda Suzuki și principiile ei fundamentale",
    '2014/1-9': "Arhitectura imaginii scenice",
    '2014/1-10': "Imaginația, produs al memoriei",
    '2014/1-11': "Schimbarea prin teatru: realitate sau utopie?",

    '2011/1-1': "Istoria teatrului japonez modern şi contemporan – perspective personale",
    '2011/1-2': "Teatrul contemporan japonez. Întâlnire cu Masahiro Jasuda şi compania sa – Yamanote Jijosha",
    '2011/1-3': "INTREBĂRI",
    '2011/1-4': "Spectacolul de poezie. Studiu de caz: Luceafărul",
    '2011/1-5': "Caricatural şi naiv în Lecţia lui Eugène Ionesco",
    '2011/1-6': "Sacrul şi profanul – motive centrale ale dramaturgiei lui Lucian Blaga",
    '2011/1-7': "Începuturile teatrului în Transilvania. Epoca Medie",
    '2011/1-8': "Antologia pieselor publicate în secţiunea „Spectacole-lectură” – un proiect editorial atipic",
    '2011/1-9': "I. L. Caragiale: exegeze scenice din ultimele decenii ale secolului XX",
    '2011/1-10': "Medeea – metamorfozele unui personaj mitic",

    '2010/2-1': "Un teatru al fracturii",
    '2010/2-2': "Despre Mama şi LaMaMa",
    '2010/2-3': "Teatru cu mâinile goale",
    '2010/2-4': "Sans surtitres: Le heurt des idiomes dans Chants d'adieux de Hirata Oriza",
    '2010/2-5': "Poezia populară, sursă fundamentală de spectacol",
    '2010/2-6': "Intonaţiile metaforei sau despre jocurile asemănării",
    '2010/2-7': "Exilul personajului în dramaturgia lui Eugène Ionesco",
    '2010/2-8': "Moartea personajului - tendinţă în teatrul postmodern. Studiu de caz: Sarah Kane",
    '2010/2-9': "Nudul pe scenă",
    '2010/2-10': "Imaginea cinematografică în spaţiul teatral",
    '2010/2-11': "I. L. Caragiale: exegeze scenice din ultimele decenii ale secolului XX. Concepţii şi viziuni regizorale: Sică Alexandrescu; particularităţi scenografice în O noapte furtunoasă. Note pe marginea Caietelor de regie",
    '2010/2-12': "Dramatizarea prozei lui I. L. Caragiale",

    '2010/1-1': "Ce au devenit avangărzile de altă dată?",
    '2010/1-2': "Eugène Ionesco – scurtă istorie a receptării",
    '2010/1-3': "Cântăreaţa cheală, pitoresc şi naiv",
    '2010/1-4': "Cele patru cetăţi ale Teatrului de Artă",
    '2010/1-5': "Moartea personajului în teatrul postmodern. Studiu de caz: Roberto Garcia",
    '2010/1-6': "Actorul în imposibilitatea unei camuflări totale",
    '2010/1-7': "O descoperire: Oreste a lui Euripide",
    '2010/1-8': "Poezia populară, sursă fundamentală de spectacol",
    '2010/1-9': "Modalităţi de realizare a expresivităţii spaţiului teatral în comediile lui I. L. Caragiale",
    '2010/1-10': "Bedeutungswandel eines ästhetischen Konzeptes: Das groteske",
    '2010/1-11': "Romanul şi filmul. Abordări teoretice",

    '2009/1-1': "O prietenie într-un secol agitat - Jerzy Grotowski şi Peter Brook",
    '2009/1-2': "Spectacolul de poezie",
    '2009/1-3': "Cehov şi Caragiale/ Patru naraţiuni de I.L. Caragiale",
    '2009/1-4': "Jurnal cu Aurel Manea",
    '2009/1-5': "Teatrul şi formele paradoxului (Pentru o estetică a artei teatrului)",
    '2009/1/6': "Călătorii în timp, Interviu cu Matei Vişniec",
    '2009/1-7': "Modalităţi de realizare a expresivităţii discursului în comediile lui Caragiale",
    '2009/1/8': "Sub imperiul imaginii. Repetiţii cu Andriy Zholdak la Turandot",
    '2009/1-9': "Pitoresc şi naiv în teatrul lui Vasile Alecsandri",
    '2009/1-10': "Teatrul jam session – o formă de teatru deteatralizat",
    '2009/1-11': "Elemente de pre-cinematograf şi cinematograf în teatrul kabuki",
  }
}
